import { BreakPointCondition, HStack, Icon, Text, useBreakpointIf } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Box, Button } from 'native-base';
import { useCallback, useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import { FilterModal } from '../../../../../../components/FilterModal';
import { useFilterTransformer } from '../../../../../../hooks/useFilterTransformer';
import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import { productsFiltersAtom } from '../../../../../../store/product/filters';
import { useGlobalProductContext } from '../../contexts';

export const ProductFilters = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { appliedFilters } = useRecoilValue(productsFiltersAtom);

  const { availableFilters, loadingCategories, hasSomeLoading, setFiltersToApply, product } =
    useGlobalProductContext();

  const { transformFilters } = useFilterTransformer(availableFilters);

  useEffect(() => {
    setFiltersToApply(
      transformFilters(appliedFilters, {
        transformDateFilter: false,
        transformRangeFieldNames: true,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedFilters]);

  if (!product.hasFilters) {
    return <></>;
  }

  return (
    <Button
      isLoading={loadingCategories}
      isLoadingText="Filtrar"
      spinnerPlacement="end"
      _text={{ textTransform: 'none' }}
      disabled={hasSomeLoading}
      onPress={() => navigate('AvailableProductsFiltersModal')}
      paddingX="inline.xxxs"
      variant="secondary"
      {...(!appliedFilters.length && { rightIcon: <Icon name="Funnel" size="xxxs" /> })}>
      <HStack alignItems="center" justifyContent="center" space="inline.nano">
        <Text variant="semibold" fontSize={Typography['fontsize.md']}>
          Filtrar
        </Text>
        {!!appliedFilters.length && (
          <Box
            rounded="full"
            w="20px"
            h="20px"
            alignItems="center"
            justifyContent="center"
            bg={'brand.tertiary.light'}>
            <Text variant="regular" fontSize={Typography['fontsize.xs']} color="neutral.white">
              {appliedFilters.length}
            </Text>
          </Box>
        )}
      </HStack>
    </Button>
  );
};

export const ProductFiltersDisabled = () => {
  return (
    <Button
      _text={{ textTransform: 'none' }}
      disabled
      isDisabled
      opacity={1}
      paddingX="inline.xxxs"
      variant="secondary"
      rightIcon={<Icon name="Funnel" size="xxxs" />}>
      <HStack alignItems="center" justifyContent="center" space="inline.nano">
        <Text variant="semibold" fontSize={Typography['fontsize.md']}>
          Filtrar
        </Text>
      </HStack>
    </Button>
  );
};

export const AvailableProductsFiltersModal = () => {
  const navigation = useNavigation();
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const getSliderModalWidth = () => {
    if (isMobile) {
      return 1;
    }
    if (isTablet) {
      return 0.5;
    }
    return 0.3;
  };

  return (
    <FilterModal
      onClose={goBack}
      sliderModalWidth={getSliderModalWidth()}
      filterAtom={productsFiltersAtom}
    />
  );
};
